<script setup lang="ts">
import { programService } from '@/api/services/program-service'
import BaseHorizontalList from '@/components/base/BaseHorizontalList.vue'
import { useIsMobile } from '@/composables/useMediaQuery'
import type { FilterOption } from '@/types/filter.types'
import { onMounted, ref } from 'vue'
import ProgramListItem from './ProgramListItem.vue'

const isMobile = useIsMobile()

const programList = ref<FilterOption[]>([])

onMounted(async () => {
  const programs = await programService.getPrograms()
  programList.value = programs
})
</script>

<template>
  <BaseHorizontalList
    v-if="programList.length > 0"
    title="프로그램 리스트"
    :showNavigation="isMobile ? false : true"
    :gap="8"
    :marginTop="isMobile ? 0 : 0"
  >
    <ProgramListItem v-for="program in programList" :key="program.idx" :item="program" />
  </BaseHorizontalList>
</template>
